export default {"src":"/_next/static/media/globe-black.38fcb83a.svg","height":14,"width":14};